import { render, staticRenderFns } from "./OntologyTermsPanel.vue?vue&type=template&id=3563dca2&scoped=true"
import script from "./OntologyTermsPanel.vue?vue&type=script&lang=js"
export * from "./OntologyTermsPanel.vue?vue&type=script&lang=js"
import style0 from "./OntologyTermsPanel.vue?vue&type=style&index=0&id=3563dca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3563dca2",
  null
  
)

export default component.exports